import React, { useMemo } from "react";
import { useAppSelector } from "../../redux/hook";
import {
  ORDER_TYPE_DELIVERY,
} from "../../constants";
import getStyles from "../OrderStatus/OrderStatus.styles";
import { Box } from "@mui/material";
import MapWithLatLng from '../Map/MapWithLatLng';
import { getRemainingDuration } from '../../utils/order';

type MapClientProps = {
  chargeId: string;
  isMobile?: boolean;
  shopName?: string;
  image?: string;
  text?: string;
  showOnlyMap?: boolean
};

export default function MapClient({
  chargeId,
  isMobile = false,
  shopName,
  image,
  text,
  showOnlyMap = false

}: MapClientProps) {


  const { drivers, orders } = useAppSelector((state) => ({
    drivers: state.driverReducer.drivers,
    shops: state.shopReducer.shops,
    orders: state.orderReducer.orders,
  }));
  const { google, secondaryColor, theme } = useAppSelector((state) => state.configurationReducer);
  const order = orders[chargeId];
  const { address, orderType } = order;
  const markerInfo = useMemo(() => {
    if (!order) return undefined;
    return getRemainingDuration(order);
  }, [order]);
  const styles = getStyles()
  const driverLocation = drivers[chargeId]?.driverLocation;
  const customerLat = address.location.latitude;
  const customerLng = address.location.longitude;

  const driverLat = driverLocation?.latitude;
  const driverLng = driverLocation?.longitude;
  const apiKey = useMemo(() => google.apiKey, [google.apiKey]);



  return (
    <Box sx={styles.mapContainer(isMobile)}>
      <MapWithLatLng
        isDelivery={orderType === ORDER_TYPE_DELIVERY}
        lat={customerLat}
        lng={customerLng}
        driverLat={driverLat}
        driverLng={driverLng}
        apiKey={apiKey}
        secondaryColor={secondaryColor}
        theme={theme}
        height="100%"
        borderRadius={0}
        mapBorderRadius='0px'
        useCustomMarker={true}
        markerInfo={markerInfo}
        shopName={shopName}
        image={image}
        text={text}
        showOnlyMap={showOnlyMap}
        withIcons={!isMobile}

      />
    </Box>
  );
}